var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-full md:pl-10 md:pr-10" }, [
    _vm.isAdmin
      ? _c("div", { staticClass: "mb-12" }, [
          _c("label", { ref: "tags", attrs: { for: "image" } }, [
            _vm._v(
              "\n            Please tag this resource with related categories to help people discover it. "
            ),
            _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-5 text-sm font-sans-book" }, [
              _vm._v("Make up to five choices."),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-wrap" },
            _vm._l(_vm.pillars, function (pillar) {
              return _c("div", { staticClass: "w-full md:w-1/2 lg:w-1/4" }, [
                _c("h2", [_vm._v(_vm._s(pillar.title))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-wrap select-box" },
                  _vm._l(pillar.tags, function (tag) {
                    return _c(
                      "div",
                      { key: tag.id, staticClass: "w-full pr-8 mb-3" },
                      [
                        _c(
                          "label",
                          { staticClass: "text-base font-sans-book" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.tags,
                                  expression: "form.tags",
                                },
                              ],
                              attrs: {
                                name: "tags",
                                type: "checkbox",
                                disabled:
                                  _vm.maxMet &&
                                  _vm.form.tags.indexOf(tag.id) == -1,
                              },
                              domProps: {
                                value: tag.id,
                                checked: Array.isArray(_vm.form.tags)
                                  ? _vm._i(_vm.form.tags, tag.id) > -1
                                  : _vm.form.tags,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.form.tags,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = tag.id,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.form,
                                          "tags",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.form,
                                          "tags",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.form, "tags", $$c)
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "inline-block mr-2 check",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "flex-1 wordbreak" }, [
                              _vm._v(_vm._s(tag.title)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("tags"),
                  expression: "errors.has('tags')",
                },
              ],
              staticClass: "text-lg error text-error-red",
            },
            [_vm._v(_vm._s(_vm.errors.first("tags")))]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-full md:pl-10 md:w-3/4 md:pr-10 mb-8" },
      [
        _vm._l(_vm.taxonomyGroups, function (group) {
          return _c("div", { key: group.id, staticClass: "mb-8" }, [
            _c("label", { ref: "taxonomy", refInFor: true }, [
              _vm._v("\n                " + _vm._s(group.title) + " "),
              _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "group__checkbox" }, [
              _c(
                "div",
                { staticClass: "flex flex-wrap select-box" },
                [
                  _vm._l(group.taxonomies, function (taxonomy) {
                    return [
                      _c(
                        "label",
                        {
                          key: taxonomy.id,
                          staticClass:
                            "w-full text-base font-normal md:w-1/2 md:pr-3",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.taxonomies,
                                expression: "form.taxonomies",
                              },
                            ],
                            attrs: { name: "taxonomy", type: "checkbox" },
                            domProps: {
                              value: taxonomy.id,
                              checked: Array.isArray(_vm.form.taxonomies)
                                ? _vm._i(_vm.form.taxonomies, taxonomy.id) > -1
                                : _vm.form.taxonomies,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.form.taxonomies,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = taxonomy.id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.form,
                                        "taxonomies",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.form,
                                        "taxonomies",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.form, "taxonomies", $$c)
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "inline-block mr-2 check",
                          }),
                          _vm._v(
                            " " +
                              _vm._s(taxonomy.title) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ])
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("taxonomy"),
                expression: "errors.has('taxonomy')",
              },
            ],
            staticClass: "text-lg error text-error-red",
          },
          [_vm._v(_vm._s(_vm.errors.first("taxonomy")))]
        ),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mb-12" }, [
      _c("label", { attrs: { for: "faiths" } }, [
        _vm._v(
          "\n            If applicable, please note any faiths this resource serves in particular.\n        "
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.faiths,
            expression: "form.faiths",
          },
        ],
        attrs: { id: "faiths", type: "text", name: "faiths" },
        domProps: { value: _vm.form.faiths },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "faiths", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-sm font-sans-italic text-gray-dark" }, [
        _vm._v("Please separate with commas."),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has("faiths"),
              expression: "errors.has('faiths')",
            },
          ],
          staticClass: "text-lg error text-error-red",
        },
        [_vm._v(_vm._s(_vm.errors.first("faiths")))]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-12" }, [
      _c("label", { attrs: { for: "faith" } }, [
        _vm._v(
          "\n            If applicable, please note any demographics this resource serves in particular.\n        "
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.demographics,
            expression: "form.demographics",
          },
        ],
        attrs: { id: "demographics", type: "text", name: "demographics" },
        domProps: { value: _vm.form.demographics },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "demographics", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-sm font-sans-italic text-gray-dark" }, [
        _vm._v(
          "Please separate with commas. e.g. seniors, ill, LGBTQ, caregivers, pet owners, etc."
        ),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has("demographics"),
              expression: "errors.has('demographics')",
            },
          ],
          staticClass: "text-lg error text-error-red",
        },
        [_vm._v(_vm._s(_vm.errors.first("demographics")))]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-6 text-right" }, [
      _c(
        "button",
        {
          staticClass: "mr-4 button",
          class: { "opacity-50 cursor-not-allowed": _vm.saving },
          attrs: { disabled: _vm.saving },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.save.apply(null, arguments)
            },
          },
        },
        [_vm.saving ? [_vm._v("Processing...")] : [_vm._v("Save")]],
        2
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button",
          class: { "opacity-50 cursor-not-allowed": _vm.saving },
          attrs: { disabled: _vm.saving },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.saveNext.apply(null, arguments)
            },
          },
        },
        [_vm._v("Save & Next")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }